
<template>
  <div class="bottom-bar greentone">
    <img src="../assets/disk.gif" data-cmd="save" v-if="showDisk && state.readyForSave">
  </div>
</template>

<style lang="scss">

  .bottom-bar {
    height: 34px;
    padding: 1px 4px;
    img {
      cursor: pointer;
    }
  }

</style>


<script>

  import state from '../data/state'

  export default{
    props: [
      'showDisk'
    ],
    data(){
      return {
        state: state
      }
    },

    ready() {
    },

    beforeDestroy() {
    },

    methods: {
      thisIsAllFake() {
        return true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BottomBar.vue?816cc0a6